// extracted by mini-css-extract-plugin
module.exports = {"button":"Stats_button__WGfsc"};